import { render } from "./HelloWorld.vue?vue&type=template&id=26ccd0b8&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=26ccd0b8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-26ccd0b8"

export default script